module.exports = __webpack_public_path__ + "static/media/seven.9e480500.jpg";